module.exports = "<div>\n    Strona przeniesiona\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main